import { Badge, Box, CloseButton, Group, Text, Tooltip } from '@mantine/core';
import { IconFile } from '@tabler/icons-react';
import style from '@theme/common.module.css';
import commonStyles from '@theme/common.module.css';
import { ReactElement } from 'react';

interface MessageInputPDFListProps {
  file: File;
  index: number;
  onRemove: (index: number) => void;
  onPreview: (file: File) => void;
  formatFileSize: (bytes: number) => string;
}

export function MessageBoxPDFList({
  file,
  index,
  onRemove,
  onPreview,
  formatFileSize,
}: MessageInputPDFListProps): ReactElement {
  const handleOpenModal = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    onPreview(file);
  };

  const handleRemove = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    onRemove(index);
  };

  return (
    <Box style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <Badge
        variant="light"
        color="#246A7A"
        size="lg"
        style={{
          width: 'fit-content',
          maxWidth: '100%',
          position: 'relative',
          cursor: 'pointer',
        }}
        className={commonStyles.badge}
        rightSection={
          <Tooltip label="Remove file" openDelay={400} bg="green.8">
            <CloseButton
              size="xs"
              color="teal"
              onClick={handleRemove}
              variant="subtle"
              style={{ borderRadius: '50%' }}
              className={style.hoverable}
            />
          </Tooltip>
        }
      >
        <Tooltip label="Preview PDF" openDelay={400} bg="green.8" onClick={handleOpenModal}>
          <Group gap={2}>
            <IconFile size={16} />
            <Text size="xs" truncate style={{ maxWidth: '120px' }} px="xs">
              {file.name}
            </Text>
            <Text size="xs">({formatFileSize(file.size)})</Text>
          </Group>
        </Tooltip>
      </Badge>
    </Box>
  );
}
